import React, { Component } from 'react'
import AmCharts from "@amcharts/amcharts3-react";

/**
 * amCharts 3 has no native "waterfall" chart type - this is the standard recipe (the same one
 * amcharts.com's own waterfall demo uses): each bar is really TWO stacked columns on one
 * valueAxis with stackType:"regular" -
 *   - an invisible "base" column (fillAlphas/lineAlpha 0) that positions where the visible
 *     bar starts (0 for a subtotal/total bar, or the running cumulative value for a delta bar)
 *   - a visible "value" column on top of it, colored per-point via colorField
 * SparcsAIHelper.buildFallbackWaterfallChart() computes {label, base, value, color} for each bar
 * server-side - this component just renders whatever bars it's given, so it works for ANY
 * waterfall (not just Acquirer Fallback) as long as the data is shaped that way.
 *
 * Props:
 *   data        - array of {label, base, value, color} objects, in display order
 *   x_axis      - category field name (defaults to "label")
 *   name        - export file name
 *   chartHeight - CSS height string (e.g. "280px")
 */
class WaterfallChart extends Component {

    render() {
        let fileName = this.props.name;
        if (fileName === null || fileName === 'null' || fileName === undefined || fileName === 'undefined') {
            fileName = "chartData";
        }

        const categoryField = this.props.x_axis || 'label';

        const config = {
            "type": "serial",
            "theme": "none",
            "dataProvider": this.props.data,
            "categoryField": categoryField,
            "categoryAxis": {
                "gridPosition": "start",
                "minorGridEnabled": false,
                "axisAlpha": 1,
                "gridAlpha": 0,
                "labelRotation": 20,
                "fontSize": 10
            },
            "valueAxes": [{
                "id": "waterfallAxis",
                "stackType": "regular",
                "axisAlpha": 0.3,
                "gridAlpha": 0.1
            }],
            "graphs": [
                {
                    // Invisible positioning column - just offsets the visible column above it.
                    "id": "base",
                    "valueField": "base",
                    "valueAxis": "waterfallAxis",
                    "type": "column",
                    "clustered": false,
                    "fillAlphas": 0,
                    "lineAlpha": 0,
                    "showBalloon": false
                },
                {
                    // The actual visible bar - colored per data point via colorField (green =
                    // recovered/success, red = failed, blue = subtotal/total - see the helper).
                    "id": "value",
                    "valueField": "value",
                    "valueAxis": "waterfallAxis",
                    "type": "column",
                    "clustered": false,
                    "colorField": "color",
                    "fillAlphas": 0.9,
                    "lineAlpha": 0.3,
                    "fixedColumnWidth": 55,
                    "balloonText": "[[category]]: [[value]]"
                }
            ],
            "marginTop": 30,
            "marginRight": 20,
            "marginLeft": 60,
            "marginBottom": 70,
            "autoMargins": false,
            "chartCursor": {
                "categoryBalloonEnabled": false,
                "cursorAlpha": 0.1,
                "zoomable": false
            },
            "export": {
                "enabled": true,
                "fileName": fileName.replace(/ /g, "_"),
                "menu": [{
                    "class": "export-main",
                    "menu": ["XLSX", "CSV"]
                }]
            }
        };

        return (
            <div className="chart_div">
                <AmCharts.React style={{ width: "100%", height: this.props.chartHeight || "280px" }} options={config} />
                <div style={{ display: 'flex', justifyContent: 'center', gap: '18px', fontSize: '11px', marginTop: '4px' }}>
                    <span><span style={{ display: 'inline-block', width: '10px', height: '10px', background: '#66bb6a', marginRight: '4px' }}></span>Recovered / Success</span>
                    <span><span style={{ display: 'inline-block', width: '10px', height: '10px', background: '#ef5350', marginRight: '4px' }}></span>Failed</span>
                    <span><span style={{ display: 'inline-block', width: '10px', height: '10px', background: '#42a5f5', marginRight: '4px' }}></span>Total</span>
                </div>
            </div>
        );
    }
}

export default WaterfallChart;
